import './empty-state.scss';
import IMAGE from '../../assets/empty-state.png';

export default function EmptyState(props) {
    
    return (
        <div className="empty-state-component text-center p-[32px] bg-[#FAFAFA]">

            <img src={IMAGE} alt={props.title} className="w-[157px] mx-auto mb-[24px]" />

            <h1 className='heading-h5 mb-[8px]'>{props.title}</h1>
            <p className='text-secundary'>{props.description}</p>

        </div>
    );
}
